import store from '@/store/store';

export const menuGroups = [
  {
    name: '首页',
    path: '/dashboard/home',
    moduleName: 'home',
    authName: '',
    icon: 'os-icon-home',
    children: [],
  },
  // {
  //   name: '客户管理',
  //   moduleName: "customerManage",
  //   authName: "customerManage",
  //   icon: 'os-icon-user-male-circle2',
  //   children: [
  //     {
  //       sub_header: '客户',
  //       authNames: ["customerList", "customerDeviceList", "customerUserList", "customerFollowUpList", "customerExportRecordList"],
  //     },
  //     {
  //       name: '客户',
  //       moduleName: "customer",
  //       authName: "customerList",
  //       path: '/dashboard/customers',
  //       icon: 'os-icon-users',
  //     },
  //     {
  //       name: '客户设备',
  //       moduleName: "customer_device",
  //       authName: "customerDeviceList",
  //       path: '/dashboard/admin/customer_devices',
  //       icon: 'os-icon-layers',
  //     },
  //     {
  //       name: '小程序用户',
  //       moduleName: "customer_user",
  //       authName: "customerUserList",
  //       path: '/dashboard/admin/customer_users',
  //       icon: 'os-icon-users',
  //       badge: 0,
  //     },
  //     {
  //       sub_header: '记录',
  //       authNames: ["customerFollowUpList", "customerExportRecordList"],
  //     },
  //     {
  //       name: '拜访记录',
  //       moduleName: "visits",
  //       authName: "customerFollowUpList",
  //       path: '/dashboard/visits',
  //       icon: 'os-icon-flag',
  //     },
  //     {
  //       name: '导出记录',
  //       moduleName: "customer_export_record",
  //       authName: "customerExportRecordList",
  //       path: '/dashboard/customer_export_records',
  //       icon: 'os-icon-download',
  //     },
  //     {
  //       sub_header: '中间商',
  //       authNames: ["dealerList"],
  //     },
  //     {
  //       name: '中间商',
  //       moduleName: "dealer",
  //       authName: "dealerList",
  //       path: '/dashboard/admin/dealers',
  //       icon: 'os-icon-users',
  //     },
  //     {
  //       sub_header: '分类列表',
  //       authNames: ["customerDeletedList", "customerRepeatList"],
  //     },
  //     {
  //       name: '待处理客户',
  //       moduleName: "customerRepeat",
  //       authName: "customerRepeatList",
  //       path: '/dashboard/customers/repeat',
  //       icon: 'os-icon-users',
  //     },
  //     {
  //       name: '已删除客户',
  //       moduleName: "customerDeleted",
  //       authName: "customerDeletedList",
  //       path: '/dashboard/customers/deleted',
  //       icon: 'os-icon-user-x',
  //     },
  //     {
  //       sub_header: '统计',
  //       authNames: ["effectiveDeviceList"],
  //     },
  //     {
  //       name: '设备数据维护',
  //       moduleName: "effective_device",
  //       authName: "effectiveDeviceList",
  //       path: '/dashboard/statistics/effective_device',
  //       icon: 'os-icon-trending-up',
  //     },
  //   ]
  // },
  {
    name: '客户管理',
    moduleName: 'customerManage',
    authName: 'customerManage',
    icon: 'os-icon-user-male-circle2',
    children: [
      // {
      //   name: '',
      //   moduleName: "",
      //   authName: "",
      //   path: '',
      //   icon: '',
      // },
      {
        sub_header: '客户',
        authNames: ['customerList'],
      },
      {
        name: '客户列表',
        moduleName: 'customer',
        authName: 'customerList',
        platform: 2,
        path: '/dashboard/customers',
        icon: 'os-icon-users',
      },
      {
        name: '最终客户',
        moduleName: 'finalCustomer',
        authName: 'customerList',
        platform: 1,
        path: '/dashboard/final_customers',
        icon: 'os-icon-users',
      },
      {
        name: '授权代理商',
        moduleName: 'authorizedCustomer',
        authName: 'customerList',
        platform: 1,
        path: '/dashboard/authorized_customers',
        icon: 'os-icon-users',
      },
      {
        name: 'OEM商',
        moduleName: 'oemCustomer',
        authName: 'customerList',
        platform: 1,
        path: '/dashboard/oem_customers',
        icon: 'os-icon-users',
      },
      {
        name: '一般经销商',
        moduleName: 'ordinaryCustomer',
        authName: 'customerList',
        platform: 1,
        path: '/dashboard/ordinary_customers',
        icon: 'os-icon-users',
      },
      {
        name: '其他',
        moduleName: 'otherCustomer',
        authName: 'customerList',
        platform: 1,
        path: '/dashboard/other_customers',
        icon: 'os-icon-users',
      },
      {
        sub_header: '设备',
        authNames: ['customerDeviceList'],
      },
      {
        name: '设备列表',
        moduleName: 'customer_device',
        authName: 'customerDeviceList',
        path: '/dashboard/admin/customer_devices',
        icon: 'os-icon-layers',
      },
      {
        name: '待归属列表',
        moduleName: 'pending_customer_device',
        authName: 'customerDeviceList',
        path: '/dashboard/admin/pending_customer_devices',
        icon: 'os-icon-layers',
      },
      {
        name: '保养记录',
        moduleName: 'device_maintainance',
        authName: 'customerDeviceMaintentanceList',
        path: '/dashboard/admin/device_maintainances',
        icon: 'os-icon-newspaper',
      },
      // {
      //   name: '发货记录',
      //   moduleName: 'customer_device_delivery',
      //   authName: 'customerDeviceDelivery',
      //   path: '/dashboard/admin/customer_device_deliveries',
      //   icon: 'os-icon-newspaper',
      // },
      {
        sub_header: '小程序',
        authNames: ['customerUserList', 'qrcodeList'],
      },
      {
        name: '用户审核',
        moduleName: 'customer_user_approve',
        authName: 'customerUserList',
        path: '/dashboard/admin/customer_users/approve',
        icon: 'os-icon-user-plus',
        badge: 0,
      },
      {
        name: '用户列表',
        moduleName: 'customer_user',
        authName: 'customerUserList',
        path: '/dashboard/admin/customer_users',
        icon: 'os-icon-users',
      },
      {
        name: '渠道二维码',
        moduleName: 'qrcode',
        authName: 'qrcodeList',
        path: '/dashboard/admin/qrcodes',
        icon: 'os-icon-fingerprint',
      },
      {
        sub_header: 'LEADS',
        authNames: ['leadsList', 'campaignList'],
      },
      {
        name: 'Leads列表',
        moduleName: 'leads',
        authName: 'leadsList',
        path: '/dashboard/leads',
        icon: 'os-icon-newspaper',
      },
      {
        name: 'Campaign列表',
        moduleName: 'campaign',
        authName: 'campaignList',
        path: '/dashboard/campaigns',
        icon: 'os-icon-server',
      },
      {
        sub_header: '记录',
        authNames: ['customerFollowUpList', 'customerExportRecordList'],
      },
      {
        name: '拜访记录',
        moduleName: 'visits',
        authName: 'customerFollowUpList',
        path: '/dashboard/visits',
        icon: 'os-icon-flag',
      },
      {
        name: '导出记录',
        moduleName: 'customer_export_record',
        authName: 'customerExportRecordList',
        path: '/dashboard/customer_export_records',
        icon: 'os-icon-download',
      },
      // {
      //   sub_header: '中间商',
      //   authNames: ["dealerList"],
      // },
      // {
      //   name: '中间商',
      //   moduleName: "dealer",
      //   authName: "dealerList",
      //   path: '/dashboard/admin/dealers',
      //   icon: 'os-icon-users',
      // },
      {
        sub_header: '其他',
        authNames: [
          'customerDeletedList',
          'customerIssueList',
          'customerRepeatList',
          'effectiveDeviceList',
        ],
      },
      {
        name: '上报信息',
        moduleName: 'customer_issue',
        authName: 'customerIssueList',
        path: '/dashboard/customer_issues',
        icon: 'os-icon-newspaper',
      },
      {
        name: '待处理客户',
        moduleName: 'customerRepeat',
        authName: 'customerRepeatList',
        path: '/dashboard/customers/repeat',
        icon: 'os-icon-users',
      },
      {
        name: '已删除客户',
        moduleName: 'customerDeleted',
        authName: 'customerDeletedList',
        path: '/dashboard/customers/deleted',
        icon: 'os-icon-user-x',
      },
      // {
      //   sub_header: '统计',
      //   authNames: ["effectiveDeviceList"],
      // },
      // {
      //   name: '设备数据维护',
      //   moduleName: "effective_device",
      //   authName: "effectiveDeviceList",
      //   path: '/dashboard/statistics/effective_device',
      //   icon: 'os-icon-trending-up',
      // },
    ],
  },
  {
    name: '报价',
    moduleName: 'sale',
    authName: 'sale',
    icon: 'os-icon-newspaper',
    children: [
      {
        name: '',
        moduleName: '',
        authName: '',
        path: '',
        icon: '',
      },
      // {
      //   sub_header: '报价单',
      //   authNames: ["quotationList"],
      // },
      // {
      //   name: '进行中',
      //   moduleName: "quotation",
      //   authName: "quotationList",
      //   path: '/dashboard/quotations',
      //   icon: 'os-icon-newspaper',
      //   badge: 0,
      // },
      // {
      //   name: '已转单',
      //   moduleName: "quotationDone",
      //   authName: "quotationList",
      //   path: '/dashboard/done/quotations',
      //   icon: 'os-icon-newspaper',
      //   badge: 0,
      // },
      // {
      //   name: '已删除',
      //   moduleName: "quotationDeleted",
      //   authName: "quotationList",
      //   path: '/dashboard/deleted/quotations',
      //   icon: 'os-icon-newspaper',
      //   badge: 0,
      // },
      {
        sub_header: '报价单',
        authNames: ['orderList'],
      },
      {
        name: '进行中',
        moduleName: 'order',
        authName: 'orderList',
        path: '/dashboard/dealer/orders',
        icon: 'os-icon-agenda-1',
        badge: 0,
      },
      {
        name: '已完成',
        moduleName: 'orderDone',
        authName: 'orderList',
        path: '/dashboard/dealer/done/orders',
        icon: 'os-icon-agenda-1',
        badge: 0,
      },
      {
        name: '已删除',
        moduleName: 'orderDeleted',
        authName: 'orderList',
        path: '/dashboard/dealer/deleted/orders',
        icon: 'os-icon-agenda-1',
        badge: 0,
      },
      {
        sub_header: '询价单',
        authNames: ['orderList'],
      },
      {
        name: '进行中',
        moduleName: 'consultOrder',
        authName: 'orderList',
        path: '/dashboard/customer/orders',
        icon: 'os-icon-agenda-1',
        badge: 0,
      },
      {
        name: '已完成',
        moduleName: 'consultOrderDone',
        authName: 'orderList',
        path: '/dashboard/customer/done/orders',
        icon: 'os-icon-agenda-1',
        badge: 0,
      },
      {
        sub_header: '采购',
        authNames: ['purchaseOrderList'],
      },
      {
        name: '采购单',
        moduleName: 'purchase_order',
        authName: 'purchaseOrderList',
        path: '/dashboard/dealer/purchase_orders',
        icon: 'os-icon-tasks-checked',
        badge: 0,
      },
    ],
  },
  {
    name: '商城',
    moduleName: 'product_promotion',
    authName: 'productPromotion',
    icon: 'os-icon-shopping-cart',
    badge: 0,
    children: [
      {
        name: '',
        moduleName: '',
        authName: '',
        path: '',
        icon: '',
      },
      {
        sub_header: '商品',
        authNames: [
          'commodityAdmin',
          'commodityCategoryList',
          'commodityList',
          'commodityPriceList',
        ],
      },
      {
        name: '商品管理',
        moduleName: 'shop_item_admin',
        authName: 'commodityAdmin',
        path: '/dashboard/shop/item_admin',
        icon: 'os-icon-database',
      },
      {
        name: '商品分类管理',
        moduleName: 'commodity_category',
        authName: 'commodityCategoryList',
        path: '/dashboard/shop/commodity_categories',
        icon: 'os-icon-server',
      },
      {
        name: '特殊价格管理',
        moduleName: 'commodity_price',
        authName: 'commodityPriceList',
        path: '/dashboard/shop/commodity_prices',
        icon: 'os-icon-dollar-sign',
      },
      {
        name: '商品列表',
        moduleName: 'commodity',
        authName: 'commodityList',
        path: '/dashboard/shop/commodities',
        icon: 'os-icon-shopping-bag',
      },
      // {
      //   name: '促销商品',
      //   moduleName: "product_promotion_promoting",
      //   authName: "commodityList",
      //   path: '/dashboard/promotions/promoting',
      //   icon: 'os-icon-tag',
      // },
      {
        sub_header: '购物车',
        authNames: ['commodityOrderManage'],
      },
      {
        name: '购物车',
        moduleName: 'cart',
        authName: 'commodityOrderManage',
        path: '/dashboard/shop/carts',
        icon: 'el-icon-shopping-cart-full',
        badge: 0,
      },
      {
        sub_header: '促销',
        authNames: ['productPromotionList'],
      },
      {
        name: '促销管理',
        moduleName: 'product_promotion_admin',
        authName: 'productPromotionList',
        path: '/dashboard/promotions/admin',
        icon: 'os-icon-tag',
      },
      {
        name: '促销历史',
        moduleName: 'product_promotion_history',
        authName: 'productPromotionList',
        path: '/dashboard/promotions/history',
        icon: 'os-icon-list',
      },
      {
        sub_header: '小程序',
        authNames: ['bannerList', 'commodityPhList', 'commodityActivityList'],
      },
      {
        name: 'Banner管理',
        moduleName: 'banner',
        authName: 'bannerList',
        path: '/dashboard/shop/banners',
        icon: 'os-icon-documents-07',
      },
      {
        name: '市场活动',
        moduleName: 'shop_activity',
        authName: 'commodityActivityList',
        path: '/dashboard/shop/activities',
        icon: 'os-icon-ui-83',
      },
      {
        name: '商品PH与设备对照表',
        moduleName: 'commodity_ph',
        authName: 'commodityPhList',
        path: '/dashboard/shop/commodity_phs',
        icon: 'os-icon-link-2',
      },
      {
        sub_header: '订单',
        authNames: ['commodityOrderList'],
      },
      // {
      //   name: '订单列表',
      //   moduleName: "commodity_order",
      //   authName: "commodityOrderList",
      //   path: '/dashboard/shop/orders',
      //   icon: 'os-icon-newspaper',
      // },
      {
        name: '待提交',
        moduleName: 'commodity_application_order',
        authName: 'commodityOrderItemUpdate',
        path: '/dashboard/shop/application_orders',
        icon: 'os-icon-newspaper',
      },
      {
        name: '待审批',
        moduleName: 'commodity_approve_order',
        authName: 'commodityOrderList',
        path: '/dashboard/shop/approve_orders',
        icon: 'os-icon-newspaper',
        badge: 0,
      },
      {
        name: '待支付',
        moduleName: 'commodity_pending_order',
        authName: 'commodityOrderList',
        path: '/dashboard/shop/pending_orders',
        icon: 'os-icon-newspaper',
        badge: 0,
      },
      {
        name: '已支付',
        moduleName: 'commodity_payed_order',
        authName: 'commodityOrderList',
        path: '/dashboard/shop/payed_orders',
        icon: 'os-icon-newspaper',
      },
      {
        name: '已完成',
        moduleName: 'commodity_done_order',
        authName: 'commodityOrderList',
        path: '/dashboard/shop/done_orders',
        icon: 'os-icon-newspaper',
      },
      {
        name: '已失效',
        moduleName: 'commodity_invalid_order',
        authName: 'commodityOrderList',
        path: '/dashboard/shop/invalid_orders',
        icon: 'os-icon-newspaper',
      },

      {
        sub_header: '配置',
        authNames: ['dealerStageDiscountList', 'shopFlowList'],
      },
      {
        name: '客户层级折扣',
        moduleName: 'dealder_stage_price',
        authName: 'dealerStageDiscountList',
        path: '/dashboard/shop/dealer_stage_price',
        icon: 'os-icon-trending-down',
      },
      {
        name: '订单审批规则',
        moduleName: 'shop_flow_set',
        authName: 'shopFlowList',
        path: '/dashboard/shop/flow_set',
        icon: 'os-icon-repeat',
      },
    ],
  },
  {
    name: '翻新设备',
    moduleName: 'used_device',
    authName: 'usedDevice',
    icon: 'os-icon-box',
    children: [
      {
        sub_header: '设备请求',
        authNames: ['deviceQuestList'],
      },
      {
        name: '求购请求',
        moduleName: 'device_quest_buying',
        authName: 'deviceQuestList',
        path: '/dashboard/device_quests/buying',
        icon: 'os-icon-inbox',
      },
      {
        name: '回收请求',
        moduleName: 'device_quest_recycle',
        authName: 'deviceQuestList',
        path: '/dashboard/device_quests/recycle',
        icon: 'os-icon-box',
      },
      {
        sub_header: '设备出售',
        authNames: ['deviceQuestList'],
      },
      {
        name: '库存管理',
        moduleName: 'used_device_index',
        authName: 'usedDeviceAdminList',
        path: '/dashboard/used_devices',
        icon: 'os-icon-shopping-cart',
      },
      {
        name: '出售列表',
        moduleName: 'used_device_sale',
        authName: 'usedDeviceSaleList',
        path: '/dashboard/used_devices/sale',
        icon: 'os-icon-shopping-cart',
      },
      {
        name: '已售出设备',
        moduleName: 'used_device_sold',
        authName: 'usedDeviceAdminList',
        path: '/dashboard/used_devices/sold',
        icon: 'os-icon-ui-02',
      },
    ],
  },
  {
    name: '服务请求管理',
    moduleName: 'serviceQuestManage',
    authName: 'serviceQuestManage',
    icon: 'os-icon-server',
    children: [
      {
        name: '',
        moduleName: '',
        authName: '',
        path: '',
        icon: '',
      },
      {
        sub_header: '维修服务',
        authNames: ['serviceQuestList', 'serviceQuestDealerList'],
      },
      {
        name: '待评估',
        moduleName: 'service_quests_new',
        authName: 'serviceQuestCreate',
        path: '/dashboard/service_quests/new',
        icon: 'os-icon-agenda-1',
        badge: 0,
      },
      {
        name: '待我处理',
        moduleName: 'service_quests_ongoing',
        authName: 'serviceQuestList',
        path: '/dashboard/service_quests/my',
        icon: 'os-icon-agenda-1',
        badge: 0,
      },
      {
        name: '请求列表',
        moduleName: 'service_quests_list',
        authName: 'serviceQuestList',
        path: '/dashboard/service_quests/list',
        icon: 'os-icon-agenda-1',
        badge: 0,
      },
      {
        name: '请求列表',
        moduleName: 'dealer_service_quests_list',
        authName: 'serviceQuestDealerList',
        path: '/dashboard/dealer_service_quests/list',
        icon: 'os-icon-agenda-1',
        badge: 0,
      },
      {
        name: '待领取',
        moduleName: 'service_quests_grab',
        authName: 'serviceQuestFlowCFSDoorService',
        path: '/dashboard/service_quests/grab',
        icon: 'os-icon-agenda-1',
        badge: 0,
      },
      {
        sub_header: '统计',
        authNames: ['serviceQuestStatistics'],
      },
      {
        name: '统计',
        moduleName: 'service_quests_statistics',
        authName: 'serviceQuestStatistics',
        path: '/dashboard/service_quests/statistics',
        icon: 'os-icon-pie-chart',
      },
      {
        sub_header: '服务评价',
        authNames: ['serverQuestComentList'],
      },
      {
        name: '评价列表',
        moduleName: 'service_quests_comment',
        authName: 'serverQuestComentList',
        path: '/dashboard/service_quests/comment',
        icon: 'os-icon-agenda-1',
        badge: 0,
      },
      {
        sub_header: '售后服务点',
        authNames: ['serviceQuestRepairList'],
      },
      {
        name: '请求列表',
        moduleName: 'repair_service_quests_list',
        authName: 'serviceQuestRepairList',
        path: '/dashboard/repair_service_quests/list',
        icon: 'os-icon-agenda-1',
        badge: 0,
      },
      {
        sub_header: '二手回收',
        authNames: ['serviceQuestList'],
      },
      {
        name: '待评估',
        moduleName: 'secondhands_new',
        authName: 'serviceQuestList',
        path: '/dashboard/secondhands/new',
        icon: 'os-icon-agenda-1',
        badge: 0,
      },
      {
        name: '正在处理中',
        moduleName: 'secondhands_ongoing',
        authName: 'serviceQuestList',
        path: '/dashboard/secondhands/processing',
        icon: 'os-icon-agenda-1',
        badge: 0,
      },
      {
        name: '已归档',
        moduleName: 'secondhands_archived',
        authName: 'serviceQuestList',
        path: '/dashboard/secondhands/archived',
        icon: 'os-icon-agenda-1',
        badge: 0,
      },
      {
        sub_header: '配置',
        authNames: [
          'ccmCategoryList',
          'serviceQuestFlowList',
        ],
      },
      {
        name: '需求分类管理',
        moduleName: 'ccm_category_list',
        authName: 'ccmCategoryList',
        path: '/dashboard/ccm_categories',
        icon: 'os-icon-server',
      },
      {
        name: '流程管理',
        moduleName: 'serviec_quest_flow',
        authName: 'serviceQuestFlowList',
        path: '/dashboard/service_quest_flows',
        icon: 'os-icon-repeat',
      },
      {
        name: '其他配置',
        moduleName: 'serviec_quest_config',
        authName: 'serviceQuestFlowList',
        path: '/dashboard/service_quest_config',
        icon: 'os-icon-settings',
      },
    ],
  },
  {
    name: '运营工具',
    moduleName: 'tool',
    authName: 'tool',
    icon: 'os-icon-command',
    children: [
      {
        sub_header: '短信',
        authNames: ['smsSend', 'smsRecord'],
      },
      {
        name: '发短信',
        moduleName: 'sms_send',
        authName: 'smsSend',
        path: '/dashboard/sms/send',
        icon: 'os-icon-mail',
      },
      {
        name: '短信记录',
        moduleName: 'sms_records',
        authName: 'smsRecord',
        path: '/dashboard/sms/records',
        icon: 'os-icon-clock',
      },
      {
        sub_header: '转换工具',
        authNames: ['deliveryToDevice'],
      },
      {
        name: '发货单转设备表',
        moduleName: 'delivery_to_device',
        authName: 'deliveryToDevice',
        path: '/dashboard/tool/delivery_to_device',
        icon: 'os-icon-repeat',
      },
    ],
  },
  {
    name: '公告',
    moduleName: 'notice',
    authName: 'notice',
    icon: 'os-icon-mail',
    children: [
      {
        sub_header: '我的公告',
        authNames: ['userNotice'],
      },
      {
        name: '我的公告',
        moduleName: 'user_notice',
        authName: 'userNotice',
        path: '/dashboard/user_notices',
        icon: 'os-icon-at-sign',
        badge: 0,
      },
      {
        sub_header: '公告管理',
        authNames: ['noticeList'],
      },
      {
        name: '草稿箱',
        moduleName: 'notice_manage',
        authName: 'noticeList',
        path: '/dashboard/notices',
        icon: 'os-icon-ui-49',
      },
      {
        name: '审批中',
        moduleName: 'notice_approve',
        authName: 'noticeList',
        path: '/dashboard/notice_approve',
        icon: 'os-icon-edit-3',
      },
      {
        name: '已发布',
        moduleName: 'notice_history',
        authName: 'noticeList',
        path: '/dashboard/notice_history',
        icon: 'os-icon-ui-34',
      },
      {
        sub_header: '分类',
        authNames: ['noticeCategoryList'],
      },
      {
        name: '公告分类',
        moduleName: 'notice_category',
        authName: 'noticeCategoryList',
        path: '/dashboard/notice_categories',
        icon: 'os-icon-server',
      },
    ],
  },
  // {
  //   name: '知识库',
  //   moduleName: "repository",
  //   authName: "repository",
  //   icon: 'os-icon-documents-17',
  //   children: [
  //     {
  //       sub_header: '知识库',
  //       authNames: ["repositoryList", "userRepository"],
  //     },
  //     {
  //       name: '草稿箱',
  //       moduleName: "repository_manage",
  //       authName: "repositoryList",
  //       path: '/dashboard/repositories',
  //       icon: 'os-icon-ui-49',
  //     },
  //     {
  //       name: '已发布',
  //       moduleName: "user_repository",
  //       authName: "userRepository",
  //       path: '/dashboard/user_repositories',
  //       icon: 'os-icon-ui-34',
  //     },
  //   ]
  // },
  {
    name: '知识库',
    moduleName: 'wiki',
    authName: 'wiki',
    icon: 'os-icon-documents-17',
    children: [
      {
        sub_header: '知识库',
        authNames: ['wikiList'],
      },
      {
        name: '设备知识库',
        moduleName: 'wiki',
        authName: 'wikiList',
        path: '/dashboard/wikis',
        icon: 'os-icon-book',
      },
      {
        sub_header: '问答',
        authNames: ['wikiCommentList'],
      },
      {
        name: '用户问答',
        moduleName: 'wiki_comment',
        authName: 'wikiCommentList',
        path: '/dashboard/wiki_comments',
        icon: 'os-icon-message-square',
      },
    ],
  },
  {
    name: '基础数据配置',
    moduleName: 'store',
    authName: 'store',
    icon: 'os-icon-database',
    children: [
      {
        name: '',
        moduleName: '',
        authName: '',
        path: '',
        icon: '',
      },
      // {
      //   sub_header: '库存',
      //   authNames: ["stockInList", "stockOutList", "storeItemList", "stockroomList"],
      // },
      // {
      //   name: '入库管理',
      //   moduleName: "stock_in",
      //   authName: "stockInList",
      //   icon: 'os-icon-plus-square',
      //   children: [
      //     {
      //       name: '入库',
      //       moduleName: "stock_in",
      //       authName: "stockInList",
      //       path: '/dashboard/store/stock_in/index',
      //       icon: 'os-icon-package',
      //     },
      //     {
      //       name: '入库记录',
      //       moduleName: "stock_in_history",
      //       authName: "stockInList",
      //       path: '/dashboard/store/stock_in/history',
      //       icon: 'os-icon-package',
      //     }
      //   ]
      // },
      // {
      //   name: '出库管理',
      //   moduleName: "stock_out",
      //   authName: "stockOutList",
      //   icon: 'os-icon-minus-square',
      //   children: [
      //     {
      //       name: '出库',
      //       moduleName: "stock_out",
      //       authName: "stockOutList",
      //       path: '/dashboard/store/stock_out/index',
      //       icon: 'os-icon-package'
      //     },
      //     {
      //       name: '出库记录',
      //       moduleName: "stock_out_history",
      //       authName: "stockOutList",
      //       path: '/dashboard/store/stock_out/history',
      //       icon: 'os-icon-package'
      //     }
      //   ]
      // },
      // {
      //   name: '库存状态',
      //   moduleName: "store_item",
      //   authName: "storeItemList",
      //   path: '/dashboard/store/store_items',
      //   icon: 'os-icon-layers',
      // },
      // {
      //   name: '仓库设置',
      //   moduleName: "store_set",
      //   authName: "stockroomList",
      //   path: '/dashboard/store/set',
      //   icon: 'os-icon-settings',
      // },
      {
        sub_header: '产品',
        authNames: ['supplierList', 'productCategoryList', 'productList'],
      },
      // {
      //   name: '供应商',
      //   moduleName: "supplier",
      //   authName: "supplierList",
      //   path: '/dashboard/dealer/suppliers',
      //   icon: 'os-icon-user-male-circle2',
      // },
      {
        name: '产品分类',
        moduleName: 'item_category',
        authName: 'productCategoryList',
        path: '/dashboard/dealer/item_categories',
        icon: 'os-icon-grid-squares-2',
      },
      {
        sub_header: '设备',
        authNames: [
          'deviceGroupList',
          'deviceCraftList',
          'maintainanceRuleList',
        ],
      },
      {
        name: '数据维护',
        moduleName: 'device_info',
        authName: 'deviceGroupList',
        path: '/dashboard/dealer/device_info',
        icon: 'os-icon-database',
      },
      {
        name: '应用与工艺管理',
        moduleName: 'device_craft',
        authName: 'deviceCraftList',
        path: '/dashboard/device_craft',
        icon: 'os-icon-newspaper',
      },
      {
        name: '保养规则管理',
        moduleName: 'maintainance_rule',
        authName: 'maintainanceRuleList',
        path: '/dashboard/maintainance_rules',
        icon: 'os-icon-list',
      },
      {
        sub_header: '其他',
        authNames: ['customConfigList'],
      },
      {
        name: '自定义配置',
        moduleName: 'custom_config',
        authName: 'customConfigList',
        path: '/dashboard/custom_configs',
        icon: 'os-icon-settings',
      },
      // {
      //   name: '产品库',
      //   moduleName: "item",
      //   authName: "productList",
      //   path: '/dashboard/dealer/items',
      //   icon: 'os-icon-database',
      // },
    ],
  },
  {
    name: '系统管理',
    moduleName: 'systemManage',
    authName: 'systemManage',
    icon: 'os-icon-settings',
    children: [
      {
        sub_header: '管理',
        authNames: [
          'userList',
          'groupList',
          'roleList',
          'resourceSetting',
          'flowList',
          'dealerInfo',
        ],
      },
      {
        name: '人员管理',
        moduleName: 'user',
        authName: 'userList',
        path: '/dashboard/admin/users',
        icon: 'os-icon-user-plus',
      },
      {
        name: '销售组管理',
        moduleName: 'dealer_group',
        authName: 'groupList',
        path: '/dashboard/dealer/groups',
        icon: 'os-icon-users',
      },
      {
        name: '角色管理',
        moduleName: 'role',
        authName: 'roleList',
        path: '/dashboard/admin/roles',
        icon: 'os-icon-users',
      },
      {
        name: '资源池管理',
        moduleName: 'resource',
        authName: 'resourceSetting',
        path: '/dashboard/admin/resources',
        icon: 'os-icon-lock',
      },
      {
        name: '流程管理',
        moduleName: 'dealer_flows',
        authName: 'flowList',
        path: '/dashboard/dealer/flows',
        icon: 'os-icon-repeat',
      },
      {
        name: '公司信息',
        moduleName: 'dealer_info',
        authName: 'dealerInfo',
        path: '/dashboard/dealer/info',
        icon: 'os-icon-info',
      },
      {
        sub_header: '日志',
        authNames: ['operationRecord'],
      },
      {
        name: '日志中心',
        moduleName: 'operation_record',
        authName: 'operationRecord',
        path: '/dashboard/admin/operation_records',
        icon: 'os-icon-info',
      },
    ],
  },
];

export default {
  isPlatformUser() {
    return store.getters.userInfo.dealer_id == 0;
  },
  belongsToDepartment(departmentNo = 0) {
    return (
      store.getters.userInfo.departments &&
      store.getters.userInfo.departments.includes(departmentNo)
    );
  },
};
